import {
  ActionIcon,
  Drawer,
  Paper,
  ScrollArea,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import { useUnit } from "effector-react";
import { useState } from "react";
import { campaignDetailsEntityModel } from "../../model/details";

export const CampaignsErrors = () => {
  const [opened, setOpened] = useState(false);

  const errors = useUnit(campaignDetailsEntityModel.$errors);

  if (!errors?.length) {
    return null;
  }

  return (
    <>
      <ActionIcon
        variant="transparent"
        c="red"
        onClick={() => setOpened(true)}
        size="lg"
      >
        <IconExclamationCircle />
      </ActionIcon>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title={
          <Title order={3} fw={500}>
            Errors
          </Title>
        }
        padding="md"
        size="lg"
      >
        <ScrollArea h="100%">
          <Stack gap="sm">
            {errors.map((error) => (
              <Paper key={error.id} p="sm" radius="md" withBorder>
                <Text fw={600}>{error.title}</Text>
                <Text c="red" size="sm">
                  {error.message}
                </Text>
              </Paper>
            ))}
          </Stack>
        </ScrollArea>
      </Drawer>
    </>
  );
};
